import {iframeAppBiLoggerFactory} from '@wix/iframe-app-bi-logger';
import assert from 'assert';
import * as Wix from 'wix-sdk'; // eslint-disable-line import/no-unresolved

function convertSchema(schema) {
  return Object.keys(schema).reduce((acc, key) => {
    const value = schema[key];
    if (value.id) {
      acc[value.id] = value;
      return acc;
    }
    return {...acc, ...convertSchema(value)};
  }, {});
}
export interface BiEvent {
  id: number;
  name: string;
  fields: string[];
}
export interface BiLogger {
  log(event: BiEvent, params): Promise<void>;
}

export const initLogger = ({
  compId,
  isOwner,
  sessionId,
  playerVersion,
  artifactVersion,
  albumId, // TODO:check
  schema,
}) => {
  const defaultParams = {
    src: 9,
    compId,
    isOwner,
    sessionId,
    playerVersion,
    artifactVersion,
    albumID: albumId,
  };
  const schemaById = convertSchema(schema);
  const loggerFactory = iframeAppBiLoggerFactory(Wix, {endpoint: 'music-ugc'}).updateDefaults(defaultParams);

  loggerFactory.loggerClientFactory.addValidator({
    match(event) {
      const {evid: eventId} = event;
      return Boolean(schemaById[eventId]);
    },
    execute(event) {
      const {evid: eventId, ...eventData} = event;
      const eventSchema = schemaById[eventId];
      const schemaFields = eventSchema.fields;
      const missingField = schemaFields.find((field) => !(field in event));
      if (missingField && !defaultParams[missingField]) {
        throw Error(`Missing field: "${missingField}"`);
      }
      const redundantField = Object.keys(eventData).find(
        (field) => schemaFields.indexOf(field) === -1 && field !== 'src' && !field.startsWith('_'),
      );

      if (redundantField) {
        throw Error(`Extra field found: "${redundantField}"`);
      }
    },
  });
  const logger = loggerFactory.logger();

  return {
    log(event, params = {}) {
      const evid = event.id;
      assert(evid, 'event id is not provided');
      return logger.log({evid, ...params});
    },
  };
};
